<template>
  <div class="field form__checkbox-container">
    <input
      :id="_uid"
      :checked="value"
      :name="label"
      type="checkbox"
      @change="$emit('input', $event.target.checked)"
    >
    <label :for="_uid">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "DSCheckbox",
  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>

</style>
